export default __webpack_public_path__ + "static/media/traffic_light_green.d1992637.png";